import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=2feb23c2&"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js&"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js&"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=2feb23c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports